module.exports = __webpack_public_path__ + "static/media/arrow_right.8e35e42d.svg";